import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.link.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("main", {
    staticClass: "imglist"
  }, [_c("a-row", [_c("a-row", [_c("draggable", {
    staticClass: "dragArea",
    attrs: {
      tag: "div",
      list: _vm.componentPathLink
    }
  }, _vm._l(_vm.componentPathLink, function (item, i) {
    return _c("div", {
      key: i,
      staticClass: "img-item",
      on: {
        click: function click($event) {
          return _vm.handleImgClick(i);
        }
      }
    }, [_c("YYImage", {
      style: {
        width: "calc(100% - 30px)",
        height: "100px",
        objectFit: "contain"
      },
      attrs: {
        lazy: false,
        fit: "contain",
        src: _vm.imgHost + item.path
      }
    }), _c("a-popconfirm", {
      attrs: {
        title: _vm.$t("com.askDelete"),
        "ok-text": _vm.$t("com.ok"),
        "cancel-text": _vm.$t("com.cancel"),
        placement: "topRight",
        overlayStyle: {
          minWidth: "200px"
        }
      },
      on: {
        confirm: function confirm($event) {
          return _vm.handleConfirmDelete(i);
        }
      }
    }, [_c("a-icon", {
      staticClass: "icon-delete",
      attrs: {
        type: "delete"
      },
      on: {
        click: function click($event) {
          $event.stopPropagation();
        }
      }
    })], 1)], 1);
  }), 0)], 1), _c("a-row", [_c("a-button", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      type: "dashed"
    },
    on: {
      click: _vm.handleAddImg
    }
  }, [_c("a-icon", {
    attrs: {
      type: "plus"
    }
  }), _vm._v(" " + _vm._s(_vm.$t("com.addPic")) + " ")], 1)], 1), _vm.componentPathLink[_vm.curImgItem] ? _c("FormEditPage", {
    staticClass: "formedit",
    attrs: {
      show: _vm.showSlide,
      title: _vm.$t("com.editPic")
    },
    on: {
      "update:show": function updateShow($event) {
        _vm.showSlide = $event;
      }
    }
  }, [_c("FileUpload", {
    attrs: {
      list: _vm.list
    },
    on: {
      success: _vm.handleUploadSuccess,
      delete: _vm.handleClearImg
    }
  }), _c("a-row", {
    style: {
      marginBottom: "24px"
    }
  }, [_c("a-radio-group", {
    on: {
      change: _vm.onTypeChange
    },
    model: {
      value: _vm.componentPathLink[_vm.curImgItem].type,
      callback: function callback($$v) {
        _vm.$set(_vm.componentPathLink[_vm.curImgItem], "type", $$v);
      },
      expression: "componentPathLink[curImgItem].type"
    }
  }, [_c("a-radio", {
    attrs: {
      value: _vm.BannerTypes.Link
    }
  }, [_vm._v(_vm._s(_vm.$t("com.link")))]), _c("a-radio", {
    attrs: {
      value: _vm.BannerTypes.Subject
    }
  }, [_vm._v(_vm._s(_vm.$t("form.subject")))])], 1)], 1), _vm.componentPathLink[_vm.curImgItem].type == _vm.BannerTypes.Link ? [typeof _vm.componentPathLink[_vm.curImgItem].name !== "undefined" ? _c("CardItem", {
    attrs: {
      title: _vm.$t("com.trackName"),
      layout: "vertical"
    }
  }, [_c("a-input", {
    attrs: {
      maxLength: 1000
    },
    model: {
      value: _vm.componentPathLink[_vm.curImgItem].name,
      callback: function callback($$v) {
        _vm.$set(_vm.componentPathLink[_vm.curImgItem], "name", $$v);
      },
      expression: "componentPathLink[curImgItem].name"
    }
  })], 1) : _vm._e(), _c("CardItem", {
    attrs: {
      title: _vm.$t("com.link")
    }
  }, [_c("a-row", {
    staticStyle: {
      "line-height": "20px",
      width: "100%"
    }
  }, [_c("a", {
    attrs: {
      target: "_blank"
    }
  }, [_vm._v(_vm._s(_vm.componentPathLink[_vm.curImgItem].link))])])], 1), _c("a-row", {
    staticStyle: {
      "margin-top": "24px"
    }
  }, [_c("a-button", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        _vm.searchParamsVisible = true;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("form.linkSet")))])], 1)] : _vm.componentPathLink[_vm.curImgItem].type == _vm.BannerTypes.Subject ? [_c("CardItem", {
    attrs: {
      title: _vm.$t("form.subjectTitle"),
      layout: "vertical"
    }
  }, [_c("a-row", {
    staticClass: "subjectTitle"
  }, [_c("Title", {
    attrs: {
      type: "input"
    },
    model: {
      value: _vm.componentPathLink[_vm.curImgItem].subjectTitle,
      callback: function callback($$v) {
        _vm.$set(_vm.componentPathLink[_vm.curImgItem], "subjectTitle", $$v);
      },
      expression: "componentPathLink[curImgItem].subjectTitle"
    }
  })], 1)], 1), _c("CardItem", {
    attrs: {
      layout: "vertical"
    }
  }, [_c("div", {
    staticStyle: {
      "margin-top": "8px",
      "line-height": "1"
    }
  }, [_c("a-button", {
    staticClass: "add_product",
    staticStyle: {
      width: "100%"
    },
    attrs: {
      type: "primary",
      icon: "plus"
    },
    on: {
      click: function click($event) {
        return _vm.addNewProduct();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("form.addProduct")) + " ")])], 1)]), _c("CardItem", {
    attrs: {
      layout: "vertical"
    }
  }, [_c("GoodsListField", {
    attrs: {
      type: "subject"
    },
    on: {
      goodsdelete: _vm.handleGoodsDelete
    },
    model: {
      value: _vm.componentPathLink[_vm.curImgItem].productList,
      callback: function callback($$v) {
        _vm.$set(_vm.componentPathLink[_vm.curImgItem], "productList", $$v);
      },
      expression: "componentPathLink[curImgItem].productList"
    }
  })], 1)] : _vm._e(), _c("a-row", {
    staticStyle: {
      "margin-top": "12px"
    }
  }, [_c("a-button", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      type: "dashed"
    },
    on: {
      click: _vm.handleDeleteImg
    }
  }, [_vm._v(_vm._s(_vm.$t("com.deletePic")))])], 1)], 2) : _vm._e()], 1), _vm.componentPathLink[this.curImgItem] ? _c("SelectProduct", {
    ref: "chooseProductRef",
    attrs: {
      "already-select": _vm.componentPathLink[this.curImgItem].product,
      invalidList: _vm.invalidList
    },
    on: {
      confirmProduct: _vm.confirmProduct
    }
  }) : _vm._e(), _vm.searchParamsVisible ? _c("SetSearchParamsModal", {
    attrs: {
      show: _vm.searchParamsVisible,
      links: _vm.componentPathLink[_vm.curImgItem].link
    },
    on: {
      "update:show": function updateShow($event) {
        _vm.searchParamsVisible = $event;
      },
      ok: _vm.handleSearchParamsOk
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };